import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { FontWeight } from '../../constants/Styles/fontWeight';
import { EditButton } from '../Button/editButton';
import { TypesButton } from '../../constants/ButtonTypes';
import { SizesButton } from '../../constants/SizeButton';
import { CatalogCategories } from '../../types/Endpoints/categories/CategoriesContracts';
import { routes } from '../../constants/RouterPath';
import { EmptyRow } from '../EmptyRow';

interface TableProps {
  className?: string;
  categories?: CatalogCategories[];
}

const styles = {
    root: {
        borderRadius: 0,
        boxShadow: 'none',
        '& .MuiTableHead-root': {
            background: '#F7F7F7',
            borderRadius: '0px',
        },
        '& .MuiTableContainer-root': {
            borderRadius: '0px',
        },
        '& .MuiPaper-root': {
            borderRadius: '0px !important',
        },

        '& . MuiTableCell-root': {
            borderBottom: '0',
        },
        '& .cell-phone': {
            maxWidth: '140px',
        },
    },
    body: {
        '& .MuiTableRow-root:hover': {
            backgroundColor: 'white',
        },
        '& .text-grey': {
            color: '#939393',
        },
        '& .cell-medium': {
            fontWeight: FontWeight.BOLD,
        },

        '& .cell-services': {
            display: 'flex',
            padding: '16px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '8px',
            flex: '1 0 0',
            alignSelf: 'stretch',
        },
    },
};

const StyledEditButton = styled(EditButton)`
    margin: 0 auto;
`;

export const CategoriesTable = ({ className, categories }: TableProps): JSX.Element => {
    const history = useHistory();

    return (
        <TableContainer className={className} component={Paper} sx={styles.root}>
            <Table sx={{ minWidth: '100%' }} aria-label="simple table">
                <TableHead sx={styles.root}>
                    <TableRow
                        sx={{
                            'td, th': { border: 0, fontWeight: FontWeight.BOLD },
                        }}
                    >
                        <TableCell>ID</TableCell>
                        <TableCell align="left">Название пользовательское</TableCell>
                        <TableCell align="left">Категория системы</TableCell>
                        <TableCell align="left">&nbsp;</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody sx={[styles.root, styles.body]}>
                    {!!categories?.length && categories.map(row => (
                        <TableRow key={row.id} sx={{ 'td, th': { border: 0, verticalAlign: 'top' } }}>
                            <TableCell component="th" scope="row" className="text-grey" sx={{ width: '10%' }}>
                                {row.id}
                            </TableCell>
                            <TableCell align="left">
                                {row.name}
                            </TableCell>
                            <TableCell align="left">
                                {row.name}
                            </TableCell>
                            <TableCell sx={{ width: '5%' }}>
                                <StyledEditButton
                                    onClick={() => history.push(`${routes.edit_category}/${row.id}`)}
                                    typeButton={TypesButton.SECONDARY}
                                    size={SizesButton.M}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                    {!categories?.length && (
                        <EmptyRow colSpan={3} />
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
